// Author thq
// Date 2024-06-05 18:44:18

import * as model from "@/model/em/spareparts/EmSparePartsInventoryCheckSicModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSparePartsInventoryCheckSic(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .buildStore()
